export default __webpack_public_path__ + "static/media/pcc-min.e3819b93.png";